import { AfterViewInit, Component, ElementRef, ViewChild, effect, input, output } from '@angular/core';
import { acceptCompletion, autocompletion } from "@codemirror/autocomplete";
import { indentWithTab } from "@codemirror/commands";
import { html } from '@codemirror/lang-html';
import { EditorState, Extension } from '@codemirror/state';
import { oneDark } from '@codemirror/theme-one-dark';
import { keymap, placeholder } from "@codemirror/view";
import { basicSetup, EditorView } from 'codemirror';
import { RouteShareService } from 'src/app/shared/services/route-share.service';

@Component({
  selector: 'app-codemirror-html',
  imports: [],
  templateUrl: './codemirror-html.component.html',
  styleUrl: './codemirror-html.component.scss'
})
export class CodemirrorHtmlComponent implements AfterViewInit {
  public readonly code = input.required<string>();
  public readonly rows = input<number>(5);
  // eslint-disable-next-line @angular-eslint/no-output-native
  public readonly finish = output<{
    code: string;
  }>();
  @ViewChild('codemirror') protected codemirror!: ElementRef<HTMLDivElement>;
  protected autocompletion = autocompletion;
  protected editorView: EditorView | undefined;
  protected editorState: EditorState | undefined;
  protected codeActionPlaceholder = $localize`:@@html-placeholder:Gib deinen HTML-Code hier ein…`;
  protected codeExtension: Extension[] = [];

  constructor(private rss: RouteShareService) {
    effect(() => {
      const code = this.code();
      if (this.editorView && this.editorState) {
        this.editorView.setState(EditorState.create({ doc: code, extensions: this.codeExtension }));
      }
    });
  }

  public ngAfterViewInit(): void {
    const editorElement = this.codemirror.nativeElement;
    //Erste Codezeile ist immer 30,39px hoch (Zeile -> 22,3906px + Space -> 8px)
    //Jede weitere Zeile fügt 22,3906px hinzu
    const heightToRows = 8 + this.rows() * 22.3906;
    this.codeExtension = [
      basicSetup,
      keymap.of([{ key: "Tab", run: acceptCompletion }, indentWithTab]),
      placeholder(this.codeActionPlaceholder),
      html(),
      EditorState.readOnly.of(!this.rss.userCanEditBotConfig()),
      oneDark,
      EditorView.theme({
        ".cm-gutters": {
          backgroundColor: "#00A599",
          color: "#fff"
        },
        ".cm-activeLineGutter": {
          backgroundColor: "#99DBD6"
        },
        ".cm-content": {
          minHeight: heightToRows + "px"
        },
        ".cm-gutter": {
          minHeight: heightToRows + "px"
        },
        "&.cm-editor": {
          height: "100%"
        },
        ".cm-scroller": {
          overflow: "auto"
        }
      }),
      EditorView.domEventHandlers({
        focusout: () => { this.saveToolConfig(); },
        keydown: (e: KeyboardEvent) => {
          if ((e.metaKey || e.ctrlKey) && e.key === 's') {
            e.stopPropagation();
            e.preventDefault();
            this.saveToolConfig();
          }
        }
      })
    ];

    try {
      this.editorState = EditorState.create({
        doc: this.code(),
        extensions: this.codeExtension
      });
    } catch (e) {
      console.error(e);
    }
    this.editorView = new EditorView({
      state: this.editorState,
      parent: editorElement
    });
  }

  public saveToolConfig() {
    if (this.editorView) {
      const currentCode = this.editorView.state.doc.toString();
      if (this.code() !== currentCode) this.finish.emit({ code: currentCode });
    }
  }
}
